import { Outlet } from 'react-router-dom';
import { TabbedLayout } from '@/modules/application/layouts/TabbedLayout';
import { TabbedLayoutTopBar } from '@/modules/application/components/TabbedLayoutTopBar';
import { MoveDownRounded } from '@mui/icons-material';
import { useTranslation } from '@/lib';

export default function MovementsLayout() {
  const { t } = useTranslation();
  const movementTabItems = [
    {
      activeRouteIds: ['/app/movements/overview'],
      label: t('overview'),
      url: '/app/movements/overview',
    },
  ];

  return (
    <TabbedLayout
      topBar={<TabbedLayoutTopBar header={t('movements')} headerIcon={<MoveDownRounded fontSize={'small'} />} tabItems={movementTabItems} />}
    >
      <Outlet />
    </TabbedLayout>
  );
}
